import type { CollageDocument } from './document';

export function grayscaleColor(color: string): string {
  const match = /^#([\da-f]{6})([\da-f]{2})?$/i.exec(color);
  if (!match?.[1]) return color;
  const rgb = Number.parseInt(match[1], 16);
  const gray = Math.round(0.2126 * ((rgb >> 16) & 255) + 0.7152 * ((rgb >> 8) & 255) + 0.0722 * (rgb & 255));
  const hex = gray.toString(16).padStart(2, '0');
  return `#${hex}${hex}${hex}${match[2] ?? ''}`;
}

export function grayscaleElement(element: CollageDocument['elements'][number]): CollageDocument['elements'][number] {
  if (element.type === 'text') return {
    ...element,
    shadowColor: grayscaleColor(element.shadowColor),
    fill: grayscaleColor(element.fill),
    depthColor: grayscaleColor(element.depthColor),
  };
  return {
    ...element,
    shadowColor: grayscaleColor(element.shadowColor),
    imageSaturation: 0,
    frame: { ...element.frame, fill: grayscaleColor(element.frame.fill), borderColor: grayscaleColor(element.frame.borderColor) },
  };
}
